import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  promotePublicGatewayQueryRoutes,
  tryRedirectPhoneGatewayQueryToMobilePwa,
} from '@kiraah-shared/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';

if (environment.Environment == 'PRODUCTION') {
  enableProdMode();
}

if (!tryRedirectPhoneGatewayQueryToMobilePwa(environment)) {
  promotePublicGatewayQueryRoutes();
  bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
}
